import axios from '@/utils/axios';

const preview = (id) => axios.get(`/sources/lightspeed/preview/${id}`);

export default {
  preview,
};
